module.exports = __webpack_public_path__ + "static/media/Group3637.108a0d96.svg";